module.exports = __webpack_public_path__ + "img/thumb_settings_deliveries.5b66e342.jpg";